import { useAuth0 } from '@auth0/auth0-react'

const SomethingWentWrong = () => {
  const { logout } = useAuth0()

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    })
  }
  return (
    <div
      className='p-6 pt-3 flex flex-col justify-center items-center h-full gap-3 border-[2px] 
        border-[var(--border-opacity,rgba(255,255,255,0.90))]
        bg-[#F5F7FF]
        backdrop-blur-[12px]'
    >
      <div className='flex flex-col justify-center items-center gap-[10px]'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='236'
          height='194'
          viewBox='0 0 236 194'
          fill='none'
        >
          <path
            d='M10.5424 4.9231H180.052C183.777 4.9232 186.795 7.94156 186.795 11.6731V145.965C186.795 149.69 183.776 152.715 180.052 152.715H10.5424C6.81131 152.715 3.79259 149.69 3.79241 145.965V11.6731C3.79241 7.94169 6.811 4.9231 10.5424 4.9231Z'
            fill='white'
            stroke='#757575'
            strokeWidth='0.655339'
          />
          <path
            d='M187.194 33.3343H3.5364V6.06561H187.194V33.3343Z'
            fill='#E4E5E7'
          />
          <path
            d='M180.121 151.98H10.6096C6.70313 151.98 3.53654 148.813 3.53654 144.907V10.6096C3.53654 6.70316 6.70313 3.53656 10.6096 3.53656H180.121C184.027 3.53656 187.194 6.70316 187.194 10.6096V144.907C187.194 148.813 184.027 151.98 180.121 151.98Z'
            stroke='#E4E5E7'
            strokeWidth='7.07308'
            strokeMiterlimit='10'
          />
          <path
            d='M135.712 21.7768H17.9084C15.9555 21.7768 14.3729 20.1942 14.3729 18.2413V17.5486C14.3729 15.5957 15.9555 14.0124 17.9084 14.0124H135.712C137.665 14.0124 139.248 15.5957 139.248 17.5486V18.2413C139.248 20.1942 137.665 21.7768 135.712 21.7768Z'
            fill='white'
          />
          <path
            d='M158.841 17.8942C158.841 20.0384 157.103 21.7771 154.959 21.7771C152.814 21.7771 151.076 20.0384 151.076 17.8942C151.076 15.7499 152.814 14.0113 154.959 14.0113C157.103 14.0113 158.841 15.7499 158.841 17.8942Z'
            fill='white'
          />
          <path
            d='M172.793 17.8939C172.793 20.0382 171.054 21.7768 168.91 21.7768C166.766 21.7768 165.028 20.0382 165.028 17.8939C165.028 15.7497 166.766 14.011 168.91 14.011C171.054 14.011 172.793 15.7497 172.793 17.8939Z'
            fill='white'
          />
          <path
            d='M117.984 123.178L95.3658 113.686L72.7474 123.178V111.212L95.3658 101.721L117.984 111.212V123.178Z'
            fill='#DA586A'
          />
          <path
            d='M153.65 87.7825H138.119V60.5138H153.65V87.7825Z'
            fill='#DA586A'
          />
          <path
            d='M52.6105 87.7825H37.0803V60.5138H52.6105V87.7825Z'
            fill='#DA586A'
          />
          <path
            d='M181.903 193.836H135.666C130.036 193.836 126.517 187.741 129.332 182.866L152.45 142.822L175.569 102.78C178.384 97.9041 185.422 97.9041 188.237 102.78L211.355 142.822L234.474 182.866C237.289 187.741 233.77 193.836 228.14 193.836H181.903Z'
            fill='#DA586A'
          />
          <path
            d='M180.469 174.505C179.557 173.607 179.108 172.521 179.122 171.247C179.136 169.974 179.6 168.916 180.514 168.071C181.429 167.226 182.59 166.812 183.997 166.828C185.404 166.843 186.555 167.283 187.451 168.147C188.346 169.012 188.787 170.081 188.773 171.354C188.759 172.628 188.286 173.703 187.355 174.581C186.423 175.459 185.27 175.89 183.897 175.875C182.522 175.86 181.38 175.403 180.469 174.505ZM179.616 140.238L188.964 140.341L187.152 163.294L180.92 163.225L179.616 140.238Z'
            fill='white'
          />
        </svg>
        <p className='text-danger-foreground text-[60px] font-sans font-bold'>
          Oops! , Something went wrong
        </p>
        <p className='text-primary-foreground text-[20px] font-sans'>
          There could be a misconfiguration in the system or a service outage.
          We track these errors automatically.
        </p>
        <div
          className='flex p-3 flex-col justify-center items-center gap-[10px] rounded-[7px] max-w-[907px]
                    border
                    border-[var(--secondary-border,rgba(0,0,0,0.30))]
                    bg-[var(--info-dim-light,#CCE5FF)]'
        >
          <div className='flex flex-col justify-center items-center gap-[10px]'>
            <p className='text-info-forground font-sans text-[20px] '>
              Still having issues please contact Spectrotel Customer Care
            </p>
            <div className='flex justify-center items-center gap-[10px]'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M8.5125 5.33436C8.40625 5.08436 8.13125 4.94999 7.86875 5.01874L7.65938 5.07499C5.99688 5.53124 4.69063 7.09686 5.06875 8.91874C6.1125 13.9375 10.0656 17.8875 15.0844 18.9344C16.9031 19.3125 18.4719 18.0062 18.925 16.3406L18.9813 16.1312C19.0531 15.8687 18.9188 15.5937 18.6656 15.4875L15.75 14.2719C15.5281 14.1812 15.275 14.2437 15.1219 14.4281L13.9781 15.825C13.8313 16.0031 13.5844 16.0594 13.3781 15.9594C11.0344 14.8469 9.15938 12.9094 8.125 10.5219C8.0375 10.3156 8.09375 10.0781 8.26875 9.93749L9.56875 8.87186C9.75313 8.72186 9.81875 8.46561 9.725 8.24374L8.5125 5.33436ZM7.60625 4.05624C8.35313 3.85311 9.1375 4.23436 9.43438 4.94999L10.65 7.86561C10.9125 8.49374 10.7313 9.22186 10.2031 9.65311L9.2 10.475C10.1063 12.3656 11.6094 13.9187 13.4594 14.8906L14.35 13.8C14.7813 13.2719 15.5063 13.0906 16.1375 13.3531L19.0531 14.5687C19.7688 14.8656 20.15 15.65 19.9469 16.3969L19.8906 16.6062C19.3375 18.6344 17.35 20.425 14.8813 19.9125C9.47188 18.7875 5.21563 14.5312 4.09063 9.12186C3.575 6.64999 5.36563 4.66561 7.39688 4.11249L7.60625 4.05624Z'
                  fill='black'
                />
              </svg>
              <p className='text-info-forground text-[18px] font-sans font-semibold'>
                888 773-9722
              </p>
            </div>
            <div className='flex justify-center items-center gap-[10px]'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M4 7.82812V7.75H4.00313C4.04063 6.77812 4.84375 6 5.82812 6H18.1719C19.1562 6 19.9563 6.77812 19.9969 7.75H20V16C20 17.1031 19.1031 18 18 18H6C4.89688 18 4 17.1031 4 16V7.82812ZM19 9.4875L13.4781 13.5344C12.5969 14.1781 11.4 14.1781 10.5219 13.5344L5 9.4875V16C5 16.5531 5.44687 17 6 17H18C18.5531 17 19 16.5531 19 16V9.4875ZM19 7.82812C19 7.37188 18.6281 7 18.1719 7H5.82812C5.37188 7 5 7.37188 5 7.82812C5 8.09063 5.125 8.34062 5.3375 8.49687L11.1125 12.7281C11.6406 13.1156 12.3594 13.1156 12.8875 12.7281L18.6625 8.49375C18.875 8.3375 19 8.09063 19 7.825V7.82812Z'
                  fill='black'
                />
              </svg>
              <p className='text-info-forground text-[18px] font-semibold'>
                customercare@spectrotel.com
              </p>
            </div>
          </div>
          <div className='h-[1px] bg-secondary-border' />
          <div className='flex gap-6'>
            <div className='flex gap-3'>
              {/* <p className='text-primary-foreground text-[18px] font-semibold font-sans'>
                Tracking ID:
              </p>
              <p className='text-primary-foreground text-[20px] font-sans'>
                037c768a55bc4502644d
              </p> */}
            </div>
          </div>
          <div className='h-[1px] bg-secondary-border' />
          <div className='flex flex-col p-6 justify-center items-center gap-[10px] rounded-[12px] bg-warning-dim-light'>
            <p className='text-danger-foreground text-[18px] font-semibold font-sans'>
              Invalid request
            </p>
            <p className='text-primary-foreground text-[18px] font-sans'>
              You may have pressed the back button, refreshed during login,
              opened too many login dialogs, or there is some issue with
              cookies, since we couldn't find your session. Try logging in again
              from the application and if the problem persists please contact
              the administrator.
            </p>
          </div>
        </div>
        <div
          className='flex py-3 px-4 justify-center items-center gap-2 rounded-[2px] bg-accent'
          onClick={handleLogout}
        >
          <button className='text-accent-foreground text-[18px] font-semibold font-sans'>
            Back to Login
          </button>
        </div>
      </div>
    </div>
  )
}
export default SomethingWentWrong
